<!--
 * @Author:
 * @LastEditTime: 2024-06-19 17:43:25
 * @Description: 承包商人员入厂
-->
<template>
  <el-card class="h-full">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="请输入姓名、联系电话"
          v-model="searchData.nameOrPhoneNumber"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50"
          placeholder="所属单位"
          v-model="searchData.contractorId"
          filterable
          clearable
        >
          <el-option
            v-for="item in contractorNames"
            :key="item.id"
            :label="item.orgName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.workflowStatus"
          size="small"
          class="mr-10px !w-50"
          placeholder="流程状态"
          filterable
          clearable
        >
          <el-option
            v-for="item in flowList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handlePersonEnter"
          :disabled="!$hasAccess('create')"
          >人员登记</el-button
        >
        <!-- <el-button
          size="small"
          type="primary"
          @click="createPersonAccount"
          :disabled="!$hasAccess('createAccount')"
          >创建账号</el-button
        > -->
        <!-- <el-button size="small" @click="handleBatchImport" :disabled="!$hasAccess('import')"
          >批量导入</el-button
        > -->
        <el-button size="small" @click="batchImoport" :disabled="!$hasAccess('import')"
          >批量导入</el-button
        >
        <el-button
          size="small"
          @click="openApprovalDialog('submit')"
          :disabled="!$hasAccess('submit')"
          >一键提交</el-button
        >
        <el-button
          size="small"
          @click="openApprovalDialog('approval')"
          :disabled="!$hasAccess('audit')"
          >一键审批</el-button
        >
      </div>
      <el-table
        :data="dataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="所属单位"
          prop="contractorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="人员类别" prop="personnelCategory">
          <template slot-scope="scope">
            <span>{{ personnelCategoryListMap(scope.row.personnelCategory) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="人员定位标签"

          prop="rydwbq"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column label="年龄" prop="age" show-overflow-tooltip width="80"></el-table-column>
        <el-table-column
          label="是否特种人员"
          prop="isSpecialOperationCertificatePersonnel"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isSpecialOperationCertificatePersonnel">是</span>
            <span v-if="!scope.row.isSpecialOperationCertificatePersonnel">否</span>
          </template>
        </el-table-column>
        <el-table-column label="工种" prop="jobs" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ jobsMap(scope.row.jobs) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="流程状态" prop="workflowStatus" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="workFlowStatusTypes(scope.row.workflowStatus)">{{
              workFlowStatusMap(scope.row.workflowStatus)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="320">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-20px"
      ></el-pagination>
    </div>

    <!-- 人员指引 -->
    <div v-if="currentComp === 'GUIDE'" class="w-full h-full">
      <div class="w-full flex justify-center items-center">
        <div class="title text-lg mb-7">人员入厂相关资料审核</div>
      </div>
      <div class="w-full detail-height">
        <person-enter-guide @back="handleBackGuide" @save="handleGo"></person-enter-guide>
      </div>
    </div>

    <!-- 详情 -->
    <div
      v-if="currentComp === 'ADD' || currentComp === 'UPDATE' || currentComp === 'DETAIL'"
      class="w-full h-full"
    >
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-10px cursor-pointer">
          <el-page-header
            v-if="pageType === 'detail' || pageType === 'approve'"
            @back="handleBack"
            content="详情"
          ></el-page-header>
          <span
            v-if="pageType !== 'detail' && pageType !== 'approve'"
            class="border-l-3 border-color-primary pl-10px text-18px"
            >{{ pageType === 'create' ? '新增' : '编辑' }}</span
          >
        </div>
        <el-button @click="openFlowDialog" v-if="$hasAccess('readFlow') && flowTaskId"
          >查看流程</el-button
        >
      </div>
      <div class="w-full form-height">
        <person-enter-content
          :FormData="FormData"
          :formList="formList"
          @back="handleBack"
          @save="handleBack"
          :pageType="pageType"
          :accountType="accountType"
          :id="$route.query.id"
          :taskId="taskId"
        ></person-enter-content>
      </div>
    </div>

    <batch-upload-zip
      v-if="uploadZipDialog"
      :uploadZipProps="uploadZipProps"
      @refreshList="getList()"
    >
    </batch-upload-zip>

    <!-- 流程弹窗 -->
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
    <!-- 导入弹窗 -->
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
    <BatchApprovalDialog
      :visible.sync="batchApprovalVisible"
      :type="dialogType"
      @finished="handleSearch"
    />
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import {
  ContractorPersonnelApi,
  ContractorApi,
  GuidanceConfigurationApi,
  ContractorPersonnelCertificateApi,
  ContractorAccountRelationApi,
  ContractorPersonnelConfigurationApi,
} from '@wiz-api/contractor-management'
import { FileApi } from '@wiz-api/file-management'
import qs from 'qs'
import utils from '@/components/safety/enumField/utils'
import PersonEnterContent from '@/components/safety/WizSafetyPage/PersonEnterContent'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import { download } from '@/assets/js/CommonDownload'
import PersonEnterGuide from '../components/PersonEnterGuide'
import BatchUploadZip from '../components/BatchUploadZip'

const contractorApi = new ContractorApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const guidanceConfigurationApi = new GuidanceConfigurationApi()
const contractorPersonnelCertificateApi = new ContractorPersonnelCertificateApi()
const contractorAccountRelationApi = new ContractorAccountRelationApi()
const contractorPersonnelConfigurationApi = new ContractorPersonnelConfigurationApi()
const fileApi = new FileApi()
const BatchApprovalDialog = () => {
  return import('../components/BatchApprovalDialog')
}
export default {
  name: 'ContractorPersonnelEnter',
  components: {
    PersonEnterContent,
    PersonEnterGuide,
    TableOperateButton,
    BatchUploadZip,
    ApprovalFlowDialog,
    BatchApprovalDialog,
  },
  data() {
    return {
      batchApprovalVisible: false,
      dialogType: '',
      operLoading: false,
      // 判断是否为承包商
      accountType: null,
      // 用于审批
      taskId: null,
      approvalFlowDialog: false,
      visible: false,
      // 用于查看流程
      flowTaskId: null,
      rowId: null,
      // 承包商负责人主键id
      contractorPersonnelId: null,
      contractorId: null,
      uploadZipDialog: false,
      uploadZipProps: {
        visible: false,
        title: '人员批量导入',
      },
      jobList: [],
      formList: [],
      // 0新增 1编辑 2删除
      pageType: 'create',
      currentComp: 'TABLE',
      FormData: {
        infDocFileName: '',
        infDocFileId: '',
        name: '',
        phoneNumber: '',
        age: null,
        idCard: '',
        sex: null,
        national: '',
        education: null,
        isTemp: true,
        personnelCategory: null,
        dutieJob: null,
        isSpecialOperationCertificatePersonnel: false,
        contractorId: undefined,
        projectId: undefined,
        headshotFileId: '',
        idCardFrontFileId: '',
        idCardReverseFileId: '',
        jobs: null,
        contractorPersonnelConfigurations: [],
        contractorPersonnelCertificates: [],
      },
      personnelCategoryList: [],
      flowList: [],
      contractorNames: [],
      row: null,
      multipleSelect: [],
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        nameOrPhoneNumber: '',
        contractorId: '',
        personnelCategory: '',
        workflowStatus: '',
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      msgDialog: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['zip'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
        maxSize: 1024, // 文件限制大小500MB
      },
      currentUser: {}, // 当前用户信息
    }
  },
  created() {
    if (localStorage.getItem('CurrentUser')) {
      this.currentUser = JSON.parse(localStorage.getItem('CurrentUser'))
    }
    // 人员入厂代办页面改造
    if (this.$route.query.id && this.$route.query.taskId && this.$route.query.mode) {
      this.taskId = this.$route.query.taskId
      this.handleEdit(
        { id: this.$route.query.id, entryFlowTaskId: this.$route.query.taskId },
        this.$route.query.mode === 'approve' ? 'audit' : 'detail'
      )
    }
    // 一队一册
    if (this.$route.query.id && this.$route.query.pageFrom === 'OneBookOneTeam') {
      this.handleEdit({ id: this.$route.query.id }, 'detail')
    }
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.WorkflowStatus',
        'ContractorManagement.DataCategory.Jobs',
        'ContractorManagement.DataCategory.PersonnelCategory',
      ],
      ['flowList', 'jobList', 'personnelCategoryList'],
      this
    )
    // 获取承包商信息
    this.getContractorInfo()
    // 获取列表
    this.getList()
    // 获取承包商名称
    this.getContractorNames()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    jobsMap() {
      return (val) => {
        return (
          this.jobList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    personnelCategoryListMap() {
      return (val) => {
        return (
          this.personnelCategoryList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    workFlowStatusMap() {
      return (val) => {
        return (
          this.flowList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEdit(val, 'detail')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEdit(val, 'update')
            },
            isShow:
              this.$hasAccess('update') &&
              [0, 3].includes(val.workflowStatus) &&
              this.currentUser.Id === val.creatorId,
          },
          {
            text: '删除',
            click: () => {
              return this.handleDel(val)
            },
            isShow:
              this.$hasAccess('delete') &&
              [0, 3].includes(val.workflowStatus) &&
              this.contractorPersonnelId !== val.id &&
              this.currentUser.Id === val.creatorId,
          },
          {
            text: '查看流程',
            click: () => {
              return this.handleEvent(val, 'readFlow')
            },
            isShow: this.$hasAccess('readFlow') && val.entryFlowTaskId,
          },
          {
            text: '提交',
            click: () => {
              return this.handleEvent(val, 'submit')
            },
            isShow:
              this.$hasAccess('submit') &&
              [0, 3].includes(val.workflowStatus) &&
              !val.isBlock &&
              val.status !== 2 &&
              !this.operLoading,
          },
          {
            text: '审批',
            click: () => {
              return this.handleEvent(val, 'audit')
            },
            // 审批code为001，且单位退厂状态为在厂
            isShow:
              this.$hasAccess('audit') &&
              val.oprateCode === '001' &&
              [1].includes(val.workflowStatus),
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  methods: {
    openApprovalDialog(type) {
      this.dialogType = type
      this.batchApprovalVisible = true
    },
    // 获取承包商信息
    async getContractorInfo() {
      // 拿承包商id和模板id
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        this.contractorId = res.contractorId
        this.contractorPersonnelId = res.contractorPersonnelId
      }
    },
    // 判断承包商负责人数据是否完整, 承包商才做此操作
    async checkPersonDataIsComplete() {
      let flag = false
      if (!this.contractorId) return
      const [err, res] = await contractorPersonnelApi.isContractorOrgLeaderCompletely()
      if (!err) {
        if (res.code) {
          if (!res.data) {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '未完善负责人信息,无法进行操作!',
            })
          } else {
            flag = true
          }
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: res.msg,
          })
        }
      }
      return flag
    },
    // 人员批量创建账号
    // async createPersonAccount() {
    //   const flag = await this.checkPersonDataIsComplete()
    //   if (this.contractorId && !flag) return
    //   this.$confirm('是否批量创建账号？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(async () => {
    //       const [err, res] = await contractorApi.contractorAcoountAndOrgMany()
    //       if (!err) {
    //         this.$message({
    //           showClose: true,
    //           message: '批量账号创建成功',
    //           type: 'success',
    //         })
    //       }
    //     })
    //     .catch(() => {})
    // },
    async handleEvent(row, type) {
      let err = null
      let res = null
      switch (type) {
        case 'submit':
          const flag = await this.checkPersonDataIsComplete()
          if (this.contractorId && !flag) return
          this.$confirm('是否确认提交当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.operLoading = true
              ;[err, res] = await contractorPersonnelApi.entrySubmit({ personId: row.id })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '提交成功',
                  type: 'success',
                })
              }
              this.handleSearch()
              this.operLoading = false
            })
            .catch(() => {})
          break
        case 'audit':
          this.taskId = this.$route.query.taskId ? this.$route.query.taskId : row.taskId
          this.handleEdit({ id: row.id, entryFlowTaskId: row.taskId }, 'audit')
          break
        case 'readFlow':
          this.flowTaskId = row.entryFlowTaskId
          this.openFlowDialog()
          break
        default:
          break
      }
    },
    // 打开流程弹框
    openFlowDialog() {
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    // 获取承包商名称列表
    async getContractorNames() {
      const [err, res] = await contractorApi.contractorNamesDto()
      if (!err) {
        this.contractorNames = res
      }
    },
    // 返回页面
    handleBackGuide() {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
      this.getContractorInfo()
      this.getList()
    },
    // 返回页面
    async handleBack() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
      this.getList()
    },
    async handleGo() {
      this.FormData = this.$options.data().FormData
      const [err, res] = await guidanceConfigurationApi.contractorPersonnelGuidanceListQuery()
      if (!err) {
        // 生成字段
        this.formList = res.map((item, index) => {
          return {
            configurationId: item.id,
            label: item.title,
            field: `field${index}`,
            textfield: `textfield${index}`,
            isRequired: item.isRequired,
          }
        })
        this.currentComp = null
        this.pageType = 'create'
        this.$nextTick(() => {
          this.currentComp = 'ADD'
        })
      }
    },
    // 人员登记
    async handlePersonEnter() {
      const flag = await this.checkPersonDataIsComplete()
      if (this.contractorId && !flag) return
      this.currentComp = null
      this.accountType = null
      this.$nextTick(() => {
        this.currentComp = 'GUIDE'
      })
    },
    // 批量导入
    async handleBatchImport() {
      const flag = await this.checkPersonDataIsComplete()
      if (this.contractorId && !flag) return
      this.uploadZipDialog = true
      this.uploadZipProps.visible = true
    },
    // 批量选中处理
    handleSelectionChange(val) {
      this.multipleSelect = val
    },
    // 详情
    async handleEdit(row, type) {
      this.FormData = this.$options.data().FormData
      // 只有在编辑的时候，或者补充资料的时候，需要用到该字段，表示是否为承包商负责人
      this.accountType = row.accountType
      this.flowTaskId = row.entryFlowTaskId || ''
      const [error, result] = await contractorPersonnelApi.get(row.id)
      if (!error) {
        this.FormData = {
          ...this.FormData,
          ...result,
        }
        // 获取证书是否提供
        const [
          errCard,
          resCard,
        ] = await contractorPersonnelCertificateApi.contractorPersonnelCertificateDto({
          contractorPersonnelId: row.id,
        })
        if (!errCard) {
          // 时间格式化
          resCard.forEach((item, index) => {
            item.certificateDate = dayjs(item.certificateDate).format('YYYY-MM-DD')
          })
          this.$set(this.FormData, 'contractorPersonnelCertificates', resCard)
        }
        // 获取资料是否提供
        const [
          err,
          res,
        ] = await contractorPersonnelConfigurationApi.contractorPersonnelConfiguration({
          contractorPersonnelId: row.id,
        })
        console.log('资料是否提供', res)
        if (!err) {
          this.formList = res.map((item, index) => {
            return {
              contractorPersonnelId: item.contractorPersonnelId,
              id: item.id,
              configurationId: item.configurationId,
              label: item.title,
              field: `field${index}`,
              textfield: `textfield${index}`,
              // 获取有无情况以及说明
              isProvided: item.isProvided,
              description: item.description,
              infDocFileId: item.infDocFileId,
            }
          })
          this.pageType = type
          this.currentComp = null
          this.$nextTick(() => {
            this.currentComp = 'UPDATE'
          })
        }
      }
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除该记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await contractorPersonnelApi.callDelete(row.id)
          if (!err) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.getList()
          }
        })
        .catch(() => {})
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取人员列表
    async getList() {
      this.tableLoading = true
      this.multipleSelect = []
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/contractor-personnels/paged-list-query?${qs.stringify(data)}`
        )
        if (res.status === 200 && res.data) {
          this.dataList = res.data.items
          this.totalCount = res.data.totalCount
        }
        this.tableLoading = false
        return
      }
      const [err, res] = await contractorPersonnelApi.pagedListQuery(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
    batchImoport() {
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await contractorPersonnelApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.resetSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await contractorPersonnelApi.downloadTemplateFile({
        returnType: 'Blob',
      })
      if (!err) {
        download('承包商人员入厂模板', res, 'application/zip')
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    async exportResults() {
      const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
        returnType: 'Blob',
      })
      if (!err) {
        download(
          '导入结果',
          res,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}

.detail-height {
  height: calc(100% - 52px);
}

.form-height {
  height: calc(100% - 25px);
}
</style>
